import { useNotificationStore } from '../../stores/useNotificationStore';
import styles from './Toast.module.css';
import clsx from 'clsx';
import CheckMarkIcon from '../../assets/icons/Сheck-mark.svg';

export const Toast = () => {
  const { notifications, removeNotification } = useNotificationStore();

  const handleToastClick = (e: React.MouseEvent | React.TouchEvent, notificationId: string) => {
    e.preventDefault();
    e.stopPropagation();
    removeNotification(notificationId);
  };

  if (notifications.length === 0) {
    return null;
  }

  return (
    <div className={styles.toastContainer}>
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className={clsx(styles.toast, styles[notification.type])}
          onClick={(e) => handleToastClick(e, notification.id)}
          onTouchEnd={(e) => handleToastClick(e, notification.id)}
        >
          <div className={styles.toastIcon}>
            {notification.type === 'success' && (
              <img src={CheckMarkIcon} alt="Success" />
            )}
            {notification.type === 'error' && (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            )}
            {notification.type === 'warning' && (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12 9V13M12 17H12.01M10.29 3.86L1.82 18C1.64532 18.3024 1.55508 18.6453 1.55696 18.9945C1.55884 19.3437 1.65276 19.6856 1.83062 19.9862C2.00849 20.2868 2.26417 20.5345 2.57198 20.7039C2.87979 20.8733 3.22718 20.9589 3.58 20.95H20.51C20.8628 20.9589 21.2102 20.8733 21.518 20.7039C21.8258 20.5345 22.0815 20.2868 22.2594 19.9862C22.4372 19.6856 22.5312 19.3437 22.533 18.9945C22.5349 18.6453 22.4447 18.3024 22.27 18L13.71 3.86C13.5317 3.56611 13.2771 3.32312 12.9728 3.15448C12.6685 2.98585 12.3245 2.89725 11.975 2.89725C11.6255 2.89725 11.2815 2.98585 10.9772 3.15448C10.6729 3.32312 10.4183 3.56611 10.24 3.86H10.29Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            )}
            {notification.type === 'info' && (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                <path d="M12 16V12M12 8H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            )}
          </div>
          <div className={styles.toastMessage}>{notification.message}</div>
        </div>
      ))}
    </div>
  );
};

